/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { Item } from '#utils/UNSAFE_dataProvider';
import { error } from '#utils/UNSAFE_logger';
import { ItemTextFunctionType, ItemTextType } from '#utils/UNSAFE_selectUtils';

export type ComponentName = 'InlineSelectSingle' | 'SelectSingle' | 'SelectMultiple';

export function renderItemText<K, D>(
  item: Item<K, D>,
  itemText: ItemTextType<K, D>,
  componentName: ComponentName
) {
  // if item-text is a string and the data has the specified field, return it;
  // otherwise log an error
  if (typeof itemText === 'string') {
    // JET-78134: in 26C rc0 preflight, line type is not editable in PRC
    // Some JS applications incorrectly pass {} as valueItem/value-item instead of null
    // or leaving it unset for the empty state. Older releases already handled that misconfiguration
    // by logging this custom error; keep that behavior and avoid throwing when item.data is missing.
    const itemData = item.data;
    if (itemData != null && Object.prototype.hasOwnProperty.call(itemData, itemText)) {
      const retData = itemData[itemText];
      return String(retData);
    }
    error(`${componentName}: itemText specifies field that does not exist: ${itemText}`);
    // return undefined if the field doesn't exist
    return undefined;
  }
  // if item-text is a function, call it to create a display label
  return (itemText as ItemTextFunctionType<K, D>)(item);
}
